import { render, staticRenderFns } from "./BlogPost.vue?vue&type=template&id=acb52320&scoped=true&"
import script from "./BlogPost.vue?vue&type=script&lang=js&"
export * from "./BlogPost.vue?vue&type=script&lang=js&"
import style1 from "./BlogPost.vue?vue&type=style&index=1&id=acb52320&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "acb52320",
  null
  
)

export default component.exports